import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpUtilsService, QueryParamsModel } from '../../_base/crud';
import { Link } from '../_models/link.model';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { currentAuthToken, currentUser } from '../../auth/_selectors/auth.selectors';
import { environment } from 'src/environments/environment';

@Injectable()
export class LinkService {
  private authToken;
  private company_id;

  constructor(
    private http: HttpClient,
    private httpUtils: HttpUtilsService,
    private store: Store<AppState>,
  ) {
    this.store.pipe(select(currentAuthToken)).subscribe((res) => (this.authToken = res));
    this.store.pipe(select(currentUser)).subscribe((res) => (this.company_id = res.companyID));
  }

  private static getLinksListQueryString(queryParams: QueryParamsModel): string {
    const { pageNumber, pageSize, sortField, sortOrder, filter } = queryParams;
    let fromString = `page=${pageNumber}&size=${pageSize}&sort=${sortField},${sortOrder}`;

    if (filter.searchTerm) {
      fromString += `&search_term=${filter.searchTerm}`;
    } else {
      if (filter.name) fromString += `&name_has=${filter.name}`;
      if (filter.value) fromString += `&value_has=${filter.value}`;
      if (filter.type) fromString += `&type_has=${filter.type}`;
      if (filter.linkGroup) fromString += `&link_group_has=${filter.linkGroup}`;
    }

    return fromString;
  }

  createLink(body: any) {
    const url = `${environment.USER_BASE}/companies/${this.company_id}/link`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.post<Link>(url, body, { headers });
  }

  findLinks(queryParams: QueryParamsModel): Observable<any> {
    const url = `${environment.USER_BASE}/companies/${this.company_id}/link`;
    const params = new HttpParams({
      fromString: LinkService.getLinksListQueryString(queryParams),
    });
    return this.http.get<any>(url, { params });
  }

  loadLinks(): Observable<any> {
    const url = `${environment.USER_BASE}/companies/${this.company_id}/link`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.get<any>(url, { headers });
  }

  updateLink(_link: Link): Observable<any> {
    const url = `${environment.USER_BASE}/companies/${this.company_id}/link/${_link.id}`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.put<Link>(url, _link, { headers });
  }

  deleteLink(linkId: number): Observable<any> {
    const url = `${environment.USER_BASE}/companies/${this.company_id}/link/${linkId}`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.delete<any>(url, { headers });
  }

  getFoldersAutoComplete(search_term: string): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders(this.authToken);
    const url =
      environment.USER_BASE + '/companies/' + this.company_id + '/link_groups?term=' + search_term;
    return this.http.get<any>(url, { headers: httpHeaders });
  }
  getLinksAutoComplete(search_term: string): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders(this.authToken);
    const url =
      environment.USER_BASE +
      '/companies/' +
      this.company_id +
      '/link_groups/autocomplete?term=' +
      search_term;
    return this.http.get<any>(url, { headers: httpHeaders });
  }
}
